/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Component imports
import { Col, Form, Input, Row, Typography } from 'antd';

// misc imports
import useTheme from '../../../../utils/hooks/useTheme';
import { FORM_CONFIGURATION_SLACK_INTEGRATION_PATH } from '../../../../constants/deploymentFormPaths';

const BotDeploymentsSlackStrategyGeneralForm=({ form, hasEditAccess })=>{
  const { t } = useTranslation();
  const { formProps } = useTheme();
  return (<Row gutter={formProps.rowGutter} className={formProps.flexDirection}>
    <Col xs={formProps.mainColSpan}>
      <Row>
        <Col flex="auto">
          <Typography.Text>
            {t('Application Settings')}
          </Typography.Text>

          <Typography.Paragraph className="fs-sm" type="secondary">
            {t('Configure the application settings')}
          </Typography.Paragraph>
        </Col>
      </Row>
    </Col>

    <Col xs={formProps.secondaryColSpan}>
      <Form.Item
        label={t('App ID')}
        name={[...FORM_CONFIGURATION_SLACK_INTEGRATION_PATH, 'appId']}
        rules={[{
          required: true,
          message: t('Please input App ID')
        }]}
      >
        {
          hasEditAccess
            ? <Input placeholder={t('Enter App ID')} />
            : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_SLACK_INTEGRATION_PATH, 'appId'])}</Typography.Text>
        }

      </Form.Item>

      <Form.Item
        label={t('Client ID')}
        name={[...FORM_CONFIGURATION_SLACK_INTEGRATION_PATH, 'clientId']}
        rules={[{
          required: true,
          message: t('Please input Client ID')
        }]}
      >
        {
          hasEditAccess
            ? <Input placeholder={t('Enter Client ID')} />
            : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_SLACK_INTEGRATION_PATH, 'clientId'])}</Typography.Text>
        }

      </Form.Item>

      <Form.Item
        label={t('Client Secret')}
        name={[...FORM_CONFIGURATION_SLACK_INTEGRATION_PATH, 'clientSecret']}
        rules={[{
          required: true,
          message: t('Please input Client Secret')
        }]}
      >
        {
          hasEditAccess
            ? <Input placeholder={t('Enter Client Secret')} />
            : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_SLACK_INTEGRATION_PATH, 'clientSecret'])}</Typography.Text>
        }
      </Form.Item>

      <Form.Item
        label={t('Team ID')}
        name={[...FORM_CONFIGURATION_SLACK_INTEGRATION_PATH, 'teamId']}
        rules={[{
          required: true,
          message: t('Please input Team ID')
        }]}
      >
        {
          hasEditAccess
            ? <Input placeholder={t('Enter Team ID')} />
            : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_SLACK_INTEGRATION_PATH, 'teamId'])}</Typography.Text>
        }
      </Form.Item>

      <Form.Item
        label={t('Chabot User OAuth Token')}
        name={[...FORM_CONFIGURATION_SLACK_INTEGRATION_PATH, 'botUserOAuthToken']}
        rules={[{
          required: true,
          message: t('Please input Agent User OAuth Token')
        }]}
      >
        {
          hasEditAccess
            ? <Input placeholder={t('Enter Agent User OAuth Token')} />
            : <Typography.Text>{form.getFieldValue([...FORM_CONFIGURATION_SLACK_INTEGRATION_PATH, 'botUserOAuthToken'])}</Typography.Text>
        }
      </Form.Item>
    </Col>
  </Row>);
};

BotDeploymentsSlackStrategyGeneralForm.propTypes = {
  form: PropTypes.object,
  hasEditAccess: PropTypes.bool
};
export default BotDeploymentsSlackStrategyGeneralForm;
